module.exports = __webpack_public_path__ + "img/tag.096e8f72.svg";